import { render, staticRenderFns } from "./LiquidLayer2LineDetails.vue?vue&type=template&id=74aa21bb&"
import script from "./LiquidLayer2LineDetails.vue?vue&type=script&lang=js&"
export * from "./LiquidLayer2LineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports